import React from 'react';
import { Loading } from 'carbon-components-react';

interface ExtractionStepProps {
  status?:
    | 'confirming_payment'
    | 'processing_file'
    | 'finding_members'
    | 'idle';
}

const STATUS_MESSAGES: { [key: string]: string } = {
  confirming_payment: 'Confirming payment...',
  processing_file: 'Processing file geometry...',
  finding_members: 'Finding matching members...',
  idle: 'Preparing...'
};

const ExtractionStep: React.FC<ExtractionStepProps> = ({ status = 'idle' }) => {
  return (
    <div className="byda-member-lookup__extraction-step">
      <Loading withOverlay={false} description="Processing" />
      <div className="byda-member-lookup__extraction-step__status-text">
        {STATUS_MESSAGES[status]}
      </div>
    </div>
  );
};

export default ExtractionStep;
